export default "__VITE_ASSET__ebf91e3e__"